import { useApiClient } from '~/api-client';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { QueueViewsResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { Banner } from '@cad-arc';

export function EventQueueErrorBanner() {
    const apiClient = useApiClient();
    const enabledFeatures = useEnabledFeatures();
    const eventQueueViewsBootstrapQuery = useQuery({
        queryKey: ['event-queue-views-bootstrap'],
        queryFn() {
            return apiClient.request<QueueViewsResource.BootstrapActiveEventQueueViews>({
                method: 'POST',
                url: 'queue_views/event_queue_views/bootstrap',
                data: {
                    agencyTypeGlobalAttrIds: [],
                    dispatchAreaIds: [],
                    queueColumnFilters: [],
                    eventQueue: 'DISPATCH',
                    isMultiAgencySubdivisionsEnabled: enabledFeatures.multiAgencySubdivisions,
                },
            });
        },
        enabled: false,
    });
    return eventQueueViewsBootstrapQuery.isError ? (
        <Banner
            status="error"
            title="Event Queues Out of Date"
            description="Data in Event Queues is out of date. Click Re-Sync to bring them back up to date."
            style={{
                marginTop: 0,
            }}
            actions={[
                {
                    children: 'Re-Sync',
                    isLoading: eventQueueViewsBootstrapQuery.isLoading,
                    variant: 'solid',
                    onClick() {
                        eventQueueViewsBootstrapQuery.refetch();
                    },
                },
            ]}
        />
    ) : (
        <></>
    );
}
